import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2019/Lic/C"; 

export const licitaciones2019 = [
    {
        // CONVOCATORIA NUM# 036
            'numConvocatoria' : 'Convocatoria No. 036/2019.',
            'idConvocatoria' : 'Convocatoria36',
            'procedimientos' : [
        // Licitación N292
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N292-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Proyecto de liberación del derecho de vía, para la construcción de la carretera a 4 carriles de Mineral del Monte-entronque Huasca; ubicado en la localidad y Municipio de Mineral del Monte, Estado de Hidalgo. (Segundo Procedimiento).',
                    'urlAnexos' : `${ ligabase }36/N292/N292.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }36/N292/JAN292.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }36/N292/APN292.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }36/N292/FAN292.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 035
            'numConvocatoria' : 'Convocatoria No. 035/2019.',
            'idConvocatoria' : 'Convocatoria35',
            'procedimientos' : [
        // Licitación N291
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N291-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción del paso superior en Blvd. Colosio entronque C.F. Pachuca - Tulancingo; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }35/N291/N291.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }35/N291/JAN291.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }35/N291/APN291.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }35/N291/FAN291.pdf`,
                    },
                    ],
                },
        // Licitación N290
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N290-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Distribuidor múltiple en Galerías, ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                    'urlAnexos' : `${ ligabase }35/N290/N290.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }35/N290/JAN290.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }35/N290/APN290.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }35/N290/FAN290.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 034
            'numConvocatoria' : 'Convocatoria No. 034/2019.',
            'idConvocatoria' : 'Convocatoria34',
            'procedimientos' : [
        // Licitación N289
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N289-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Distribuidor vial Venta Prieta (Km 85+800); ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N289/N289.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N289/JAN289.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N289/APN289.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }34/N289/AMDAPN289.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }34/N289/FAN289.pdf`,
                    },
                    ],
                },
        // Licitación N288
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N288-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de techumbre en la Universidad Tecnológica de Tulancingo, Campus Santa Úrsula; ubicada en la localidad de Santa Úrsula, Municipio de Huehuetla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N288/N288.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N288/JAN288.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N288/APN288.pdf`,
                    },
                    ],
                },
        // Licitación N287
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N287-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Reconstrucción del camino E.C. Uxdejhé (Estatal 101)-Yextho Chico, del Km. 0+000 al Km. 3+000, subtramo 0+000 al Km 0+500; ubicada en la localidad de Uxdejhe, Municipio de Tecozautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N287/N287.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N287/JAN287.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N287/APN287.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }34/N287/FAN287.pdf`,
                    },
                    ],
                },
        // Licitación N286
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N286-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico con huellas vehiculares de piedra, colonia San Javier; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N286/N286.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N286/JAN286.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N286/APN286.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }34/N286/FAN286.pdf`,
                    },
                    ],
                },
        // Licitación N285
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N285-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de calles El Tephé - La Peña; ubicada en la localidad de El Tephé, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N285/N285.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N285/JAN285.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N285/APN285.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }34/N285/FAN285.pdf`,
                    },
                    ],
                },
        // Licitación N284
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N284-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de techado de cancha de usos múltiples en Esc. Preescolar Margarita Maza de Juárez CCT13DCC0616Q; ubicada en la localidad de El Bingu, Municipio de Cardonal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N284/N284.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N284/JAN284.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N284/APN284.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }34/N284/FAN284.pdf`,
                    },
                    ],
                },
        // Licitación N283
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N283-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica acceso a La Encarnación (huellas vehiculares); ubicada en la localidad de Encarnación, Municipio de Zimapán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N283/N283.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N283/JAN283.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N283/APN283.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }34/N283/FAN283.pdf`,
                    },
                    ],
                },
        // Licitación N282
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N282-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de guarniciones y banquetas en la calle, La Cabaña con 440 ML; ubicada en la localidad de El Tephé, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N282/N282.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N282/JAN282.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N282/APN282.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }34/N282/FAN282.pdf`,
                    },
                    ],
                },
        // Licitación N281
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N281-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Rastreo y reafinamiento de caminos de Pachuca; ubicada en la localidad de San Bartolo (Ejido Villa Aquiles Serdán), Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N281/N281.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N281/JAN281.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N281/APN281.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }34/N281/AMDAPN281.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }34/N281/FAN281.pdf`,
                    },
                    {
                        'resultado' : 'Fe de erratas',
                        'urlresultado' : `${ ligabase }34/N281/FRRN281.pdf`,
                    },
                    ],
                },
        // Licitación N280
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N280-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Manejo sustentable del sistema de distribución del agua potable; ubicada en la localidad de La Heredad, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N280/N280.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N280/JAN280.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N280/APN280.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }34/N280/FAN280.pdf`,
                    },
                    ],
                },
        // Licitación N279
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N279-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de guarniciones y banquetas en La Heredad; ubicada en la localidad de La Heredad, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N279/N279.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N279/JAN279.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N279/APN279.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }34/N279/FAN279.pdf`,
                    },
                    ],
                },
        // Licitación N278
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N278-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Ampliación de dren pluvial; ubicada en la localidad de Dios Padre, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N278/N278.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N278/JAN278.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N278/APN278.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }34/N278/FAN278.pdf`,
                    },
                    ],
                },
        // Licitación N277
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N277-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de albergue en Hospital Regional de Ixmiquilpan; ubicada en la localidad de Taxadho, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N277/N277.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N277/JAN277.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N277/APN277.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }34/N277/FAN277.pdf`,
                    },
                    ],
                },
        // Licitación N276
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N276-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Ampliación de red de drenaje sanitario, Taxadhó; ubicada en la localidad de Taxadho, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N276/N276.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N276/JAN276.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N276/APN276.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }34/N276/FAN276.pdf`,
                    },
                    ],
                },
        // Licitación N275
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N275-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en La Puebla; ubicada en la localidad de La Puebla, Municipio de Atotonilco El Grande, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N275/N275.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N275/JAN275.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N275/APN275.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }34/N275/FAN275.pdf`,
                    },
                    ],
                },
        // Licitación N274
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N274-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Ampliación de drenaje sanitario Los Pinos Remedios; ubicada en la localidad de Los Pinos, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N274/N274.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N274/JAN274.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N274/APN274.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }34/N274/FAN274.pdf`,
                    },
                    ],
                },
        // Licitación N273
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N273-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en el Paso de Amajac; ubicada en la localidad de Paso de Amajac, Municipio de Atotonilco El Grande, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N273/N273.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N273/JAN273.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N273/APN273.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }34/N273/FAN273.pdf`,
                    },
                    ],
                },
        // Licitación N272
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N272-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Estudio y proyecto para alcantarillado sanitario y planta de tratamiento de aguas residuales en Caltimacán; ubicada en la localidad de Caltimacán, Municipio de Tasquillo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N272/N272.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }34/N272/JAN272.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }34/N272/APN272.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 033
            'numConvocatoria' : 'Convocatoria No. 033/2019.',
            'idConvocatoria' : 'Convocatoria33',
            'procedimientos' : [
        // Licitación N271
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N271-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación Vicente Guerrero - Telesecundaria; ubicada en la localidad de San Antonio El Grande, Municipio de Huehuetla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N271/N271.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N271/JAN271.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N271/APN271.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N271/FAN271.pdf`,
                    },
                    ],
                },
        // Licitación N270
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N270-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Terminación de Centro Gerontológico Integral; ubicada en la localidad de Huextetitla, Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N270/N270.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N270/JAN270.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N270/APN270.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N270/FAN270.pdf`,
                    },
                    ],
                },
        // Licitación N269
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N269-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Repavimentación de calle Corregidora Ixmiquilpan centro; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N269/N269.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N269/JAN269.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N269/APN269.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N269/FAN269.pdf`,
                    },
                    ],
                },
        // Licitación N268
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N268-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de techado de cancha de usos múltiples; ubicada en la localidad de El Huacri, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N268/N268.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N268/JAN268.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N268/APN268.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N268/FAN268.pdf`,
                    },
                    ],
                },
        // Licitación N267
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N267-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de calle Miguel Hidalgo; ubicada en la localidad de El Nith, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N267/N267.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N267/JAN267.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N267/APN267.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N267/FAN267.pdf`,
                    },
                    ],
                },
        // Licitación N266
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N266-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Reconstrucción de pavimentación asfáltica de calle Circuito Bella Vista Loma, Julián Villagrán; ubicada en la localidad de La Loma Julián Villagrán, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N266/N266.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N266/JAN266.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N266/APN266.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N266/FAN266.pdf`,
                    },
                    ],
                },
        // Licitación N265
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N265-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle acceso principal, de la colonia Panotlán; ubicada en la localidad de Zacualtipán, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N265/N265.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N265/JAN265.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N265/APN265.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N265/FAN265.pdf`,
                    },
                    ],
                },
        // Licitación N264
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N264-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de calles: Álvaro Obregón, 2a Álvaro Obregón y Cuauhtémoc; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N264/N264.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N264/JAN264.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N264/APN264.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N264/FAN264.pdf`,
                    },
                    ],
                },
        // Licitación N263
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N263-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica con banquetas y guarniciones en la localidad de Panales; ubicada en la localidad de Panales, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N263/N263.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N263/JAN263.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N263/APN263.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N263/FAN263.pdf`,
                    },
                    ],
                },
        // Licitación N262
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N262-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle Atopixco Obsidiana; ubicada en la localidad de Atopixco, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N262/N262.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N262/JAN262.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N262/APN262.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N262/FAN262.pdf`,
                    },
                    ],
                },
        // Licitación N261
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N261-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle acceso principal Tizapan; ubicada en la localidad de Tizapan, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N261/N261.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N261/JAN261.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N261/APN261.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N261/FAN261.pdf`,
                    },
                    ],
                },
        // Licitación N260
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N260-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle Belisario Domínguez; ubicada en la localidad de Fitzhi, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N260/N260.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N260/JAN260.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N260/APN260.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N260/FAN260.pdf`,
                    },
                    ],
                },
        // Licitación N259
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N259-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de guarniciones y banquetas en la calle, Circuito Tepathé con 1,200 ml; ubicada en la localidad de El Tephé, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N259/N259.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N259/JAN259.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N259/APN259.pdf`,
                    },
                    ],
                },
        // Licitación N258
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N258-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Reconstrucción de pavimentación asfáltica de calle Corregidora y Javier Mina, col. Centro y Carmen; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N258/N258.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N258/JAN258.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N258/APN258.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N258/FAN258.pdf`,
                    },
                    ],
                },
        // Licitación N257
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N257-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de guarniciones y banquetas en la calle, Peñas tramo 1 y 2 con 2,420 ml; ubicada en la localidad de El Tephé, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N257/N257.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N257/JAN257.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N257/APN257.pdf`,
                    },
                    ],
                },
        // Licitación N256
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N256-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de andador San Antonio el Grande-clínica; ubicada en la localidad de San Antonio El Grande, Municipio de Huehuetla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N256/N256.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N256/JAN256.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N256/APN256.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N256/FAN256.pdf`,
                    },
                    ],
                },
        // Licitación N255
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N255-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle sin nombre; ubicada en la localidad de Boxtha Chico, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N255/N255.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N255/JAN255.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N255/APN255.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N255/FAN255.pdf`,
                    },
                    ],
                },
        // Licitación N254
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N254-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calles Francisco Villa y Francisco I. Madero; ubicada en la localidad de El Bondho, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N254/N254.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N254/JAN254.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N254/APN254.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N254/FAN254.pdf`,
                    },
                    ],
                },
        // Licitación N253
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N253-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica de acceso El Colorado; ubicada en la localidad de El Colorado (Cerro Colorado), Municipio de Chapantongo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N253/N253.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N253/JAN253.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N253/APN253.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N253/FAN253.pdf`,
                    },
                    ],
                },
        // Licitación N252
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N252-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación en acceso principal en calle Ocampo primera etapa; ubicada en la localidad de Zacualtipán, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N252/N252.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N252/JAN252.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N252/APN252.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N252/FAN252.pdf`,
                    },
                    ],
                },
        // Licitación N251
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N251-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Rehabilitación de pavimentación asfáltica El Espino; ubicada en la localidad de El Espino, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N251/N251.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N251/JAN251.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N251/APN251.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N251/FAN251.pdf`,
                    },
                    ],
                },
        // Licitación N250
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N250-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica prolongación Lázaro Cárdenas; ubicada en la localidad de El Nith, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N250/N250.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N250/JAN250.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N250/APN250.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N250/FAN250.pdf`,
                    },
                    ],
                },
        // Licitación N249
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N249-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de guarniciones y banquetas en la calle Serapio Torres C. con 780 ml; ubicada en la localidad de El Tephé, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N249/N249.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N249/JAN249.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N249/APN249.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N249/FAN249.pdf`,
                    },
                    ],
                },
        // Licitación N248
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N248-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de guarniciones y banquetas en la calle, Los Hernández con 600 ml; ubicada en la localidad de El Tephé, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N248/N248.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N248/JAN248.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N248/APN248.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N248/FAN248.pdf`,
                    },
                    ],
                },
        // Licitación N247
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N247-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica de calle principal; ubicada en la localidad de El Botho, Municipio de Cardonal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N247/N247.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N247/JAN247.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N247/APN247.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N247/FAN247.pdf`,
                    },
                    ],
                },
        // Licitación N246
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N246-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle 16 de Septiembre; ubicada en la localidad de San Andrés, Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N246/N246.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N246/JAN246.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N246/APN246.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N246/FAN246.pdf`,
                    },
                    ],
                },
        // Licitación N245
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N245-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle en la localidad de Cacala; ubicada en la localidad de Zacualtipán, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N245/N245.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N245/JAN245.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N245/APN245.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N245/FAN245.pdf`,
                    },
                    ],
                },
        // Licitación N244
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N244-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Centenario; ubicada en la localidad de Teltipán de Juárez, Municipio de  Tlaxcoapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N244/N244.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N244/JAN244.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N244/APN244.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N244/FAN244.pdf`,
                    },
                    ],
                },
        // Licitación N243
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N243-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en calle González Ortega; ubicada en la localidad de Poxindeje de Morelos, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N243/N243.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N243/JAN243.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N243/APN243.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N243/FAN243.pdf`,
                    },
                    ],
                },
        // Licitación N242
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N242-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de diciembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en c. Venustiano Carranza en la cabecera municipal; ubicada en la localidad y Municipio de San Bartolo Tutotepec, Estado de Hidalgo. (Segundo Procedimiento).',
                    'urlAnexos' : `${ ligabase }33/N242/N242.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }33/N242/JAN242.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }33/N242/APN242.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }33/N242/FAN242.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 032
            'numConvocatoria' : 'Convocatoria No. 032/2019.',
            'idConvocatoria' : 'Convocatoria32',
            'procedimientos' : [
        // Licitación N241
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N241-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 al 29 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Diversificación productiva e incremento a la productividad piscícola en la Granja Integral de Policultivo; ubicada en la localidad de Santiago Acayutlan, Municipio de Tezontepec de Aldama, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }32/N241/N241.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }32/N241/JAN241.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }32/N241/APN241.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }32/N241/FAN241.pdf`,
                    },
                    ],
                },
        // Licitación N240
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N240-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 al 29 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación y modernización del Boulevard  Luis Donaldo Colosio, tramo 5; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }32/N240/N240.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }32/N240/JAN240.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }32/N240/APN240.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }32/N240/FAN240.pdf`,
                    },
                    ],
                },
        // Licitación N239
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N239-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 al 29 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación y modernización del Boulevard  Luis Donaldo Colosio, tramo 4; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }32/N239/N239.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }32/N239/JAN239.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }32/N239/APN239.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }32/N239/FAN239.pdf`,
                    },
                    ],
                },
        // Licitación N238
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N238-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 al 29 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación y modernización del Boulevard  Luis Donaldo Colosio, tramo 3; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }32/N238/N238.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }32/N238/JAN238.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }32/N238/APN238.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }32/N238/FAN238.pdf`,
                    },
                    ],
                },
        // Licitación N237
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N237-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 al 29 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación y modernización del Boulevard  Luis Donaldo Colosio, tramo 2; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }32/N237/N237.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }32/N237/JAN237.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }32/N237/APN237.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }32/N237/FAN237.pdf`,
                    },
                    ],
                },
        // Licitación N236
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N236-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 25 al 29 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación y modernización del Boulevard  Luis Donaldo Colosio, tramo 1; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }32/N236/N236.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }32/N236/JAN236.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }32/N236/APN236.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }32/N236/FAN236.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 031
            'numConvocatoria' : 'Convocatoria No. 031/2019.',
            'idConvocatoria' : 'Convocatoria31',
            'procedimientos' : [
        // Licitación N235
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N235-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Proyecto de liberación del derecho de vía, para la construcción de la carretera a 4 carriles de Mineral del Monte-entronque Huasca; ubicado en la localidad y Municipio de Mineral del Monte, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N235/N235.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }31/N235/JAN235.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }31/N235/APN235.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }31/N235/FAN235.pdf`,
                    },
                    ],
                },
        // Licitación N234
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N234-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción del circuito Tulancingo - Cuautepec del Km 0+400 al Km 0+840; ubicada en la localidad y Municipio de Cuautepec de Hinojosa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N234/N234.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }31/N234/JAN234.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }31/N234/APN234.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }31/N234/FAN234.pdf`,
                    },
                    ],
                },
        // Licitación N233
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N233-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Reconstrucción de lateral Felipe Ángeles, tramo Tec de Pachuca-Aeropuerto Km 0+000 al Km 3+000; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N233/N233.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }31/N233/JAN233.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }31/N233/APN233.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }31/N233/FAN233.pdf`,
                    },
                    ],
                },
        // Licitación N232
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N232-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Reconstrucción de lateral Felipe Ángeles, tramo Lienzo Charro-Ford Km 0+000 al Km 2+400; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N232/N232.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }31/N232/JAN232.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }31/N232/APN232.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }31/N232/FAN232.pdf`,
                    },
                    ],
                },
        // Licitación N231
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N231-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción distribuidor vial Luis Donaldo Colosio entronque con Av. Universidad (CEUNI); de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }31/N231/N231.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }31/N231/JAN231.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }31/N231/APN231.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }31/N231/FAN231.pdf`,
                    },
                    ],
                },
        // Licitación N230
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N230-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Elevadores puentes peatonales (IMSS-SEP-Juan  C. Doria); ubicados en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N230/N230.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }31/N230/JAN230.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }31/N230/APN230.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }31/N230/FAN230.pdf`,
                    },
                    ],
                },
        // Licitación N229
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N229-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 19 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción del distribuidor vial ubicado en Blvd. Felipe Ángeles y Blvd. Luis Donaldo Colosio (puente atirantado),  ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N229/N229.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }31/N229/JAN229.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }31/N229/APN229.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }31/N229/FAN229.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 030
            'numConvocatoria' : 'Convocatoria No. 030/2019.',
            'idConvocatoria' : 'Convocatoria30',
            'procedimientos' : [
        // Licitación N228
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N228-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Estudio y proyecto para la construcción  del puente vehicular para conectar Santa Ana Ahuehuepan, comunidad El Chivo;  ubicada en la localidad de Santa Ana Ahuehuepan, Municipio de Tula de Allende, Estado de Hidalgo. (Segundo Procedimiento).',
                    'urlAnexos' : `${ ligabase }30/N228/N228.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }30/N228/JAN228.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }30/N228/APN228.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }30/N228/FAN228.pdf`,
                    },
                    ],
                },
        // Licitación N227
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N227-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico Enzuelado-Carpinteros; ubicada en la localidad de Carpinteros, Municipio de San Agustín Metzquititlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N227/N227.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }30/N227/JAN227.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }30/N227/APN227.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }30/N227/FAN227.pdf`,
                    },
                    ],
                },
        // Licitación N226
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N226-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de hidráulica en c. principal en la comunidad de San Jerónimo; ubicada en la localidad de San Jerónimo, Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N226/N226.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }30/N226/JAN226.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }30/N226/APN226.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }30/N226/FAN226.pdf`,
                    },
                    ],
                },
        // Licitación N225
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N225-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico c. Benito Juárez, en la cabecera municipal; ubicada en la localidad y Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N225/N225.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }30/N225/JAN225.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }30/N225/APN225.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }30/N225/FAN225.pdf`,
                    },
                    ],
                },
        // Licitación N224
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N224-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de hidráulica en c. principal en la comunidad de San Mateo; ubicada en la localidad de San Mateo, Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N224/N224.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }30/N224/JAN224.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }30/N224/APN224.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }30/N224/FAN224.pdf`,
                    },
                    ],
                },
        // Licitación N223
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N223-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en las principales calles de la cabecera municipal; ubicada en la localidad y Municipio de Huehuetla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N223/N223.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }30/N223/JAN223.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }30/N223/APN223.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }30/N223/FAN223.pdf`,
                    },
                    ],
                },
        // Licitación N222
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N222-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en c. Manuel Doblado, en la cabecera municipal; ubicada en la localidad y Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N222/N222.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }30/N222/JAN222.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }30/N222/APN222.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }30/N222/FAN222.pdf`,
                    },
                    ],
                },
        // Licitación N221
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N221-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en c. Venustiano Carranza en la cabecera municipal; ubicada en la localidad y Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N221/N221.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }30/N221/JAN221.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }30/N221/APN221.pdf`,
                    },
                    ],
                },
        // Licitación N220
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N220-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Museo Cultural; ubicado en la localidad y Municipio de Santiago de Anaya, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N220/N220.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }30/N220/JAN220.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }30/N220/APN220.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }30/N220/FAN220.pdf`,
                    },
                    ],
                },
        // Licitación N219
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N219-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de camino principal de Tapancos; ubicada en la localidad de Los Tapancos, Municipio de Omitlán de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N219/N219.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }30/N219/JAN219.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }30/N219/APN219.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }30/N219/FAN219.pdf`,
                    },
                    ],
                },
        // Licitación N218
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N218-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en c. Brasil; ubicada en la localidad y Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N218/N218.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }30/N218/JAN218.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }30/N218/APN218.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }30/N218/FAN218.pdf`,
                    },
                    ],
                },
        // Licitación N217
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N217-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle La Chimenea en el Barrio El Aviadero; ubicada en la localidad y Municipio de Omitlán de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N217/N217.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }30/N217/JAN217.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }30/N217/APN217.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }30/N217/FAN217.pdf`,
                    },
                    ],
                },
        // Licitación N216
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N216-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Modernización de Boulevard Tizayuca 2º etapa; ubicada en la localidad y Municipio de Tizayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N216/N216.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }30/N216/JAN216.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }30/N216/APN216.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }30/N216/FAN216.pdf`,
                    },
                    ],
                },
        // Licitación N215
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N215-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica Blvd. La Cruz Ote, tramo 3, Fracc. Haciendas de Tizayuca, ubicada en la localidad y Municipio de Tizayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N215/N215.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }30/N215/JAN215.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }30/N215/APN215.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }30/N215/FAN215.pdf`,
                    },
                    ],
                },
        // Licitación N214
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N214-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Sistema de agua potable Chiconcuac; ubicada en la localidad de Chiconcoac, Municipio de Lolotla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N214/N214.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }30/N214/JAN214.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }30/N214/APN214.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }30/N214/FAN214.pdf`,
                    },
                    ],
                },
        // Licitación N213
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N213-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico 3era. Etapa;  ubicada en la localidad de Chiquitla, Municipio de Lolotla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N213/N213.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }30/N213/JAN213.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }30/N213/APN213.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }30/N213/FAN213.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 029
            'numConvocatoria' : 'Convocatoria No. 029/2019.',
            'idConvocatoria' : 'Convocatoria29',
            'procedimientos' : [
        // Licitación N212
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N212-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica Blvd. La Cruz Ote. tramo 3-2 izquierdo, Fracc. Haciendas de Tizayuca; ubicada en la localidad y Municipio de Tizayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N212/N212.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N212/JAN212.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N212/APN212.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N212/FAN212.pdf`,
                    },
                    ],
                },
        // Licitación N211
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N211-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de Av. de la Cruz sur (tramo de Av. de Las Partidas a Blvd. La Cruz Poniente), Fracc. Haciendas de Tizayuca; ubicada en la localidad y Municipio de Tizayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N211/N211.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N211/JAN211.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N211/APN211.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N211/FAN211.pdf`,
                    },
                    ],
                },
        // Licitación N210
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N210-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de Av. Rancho Don Antonio (tramo del Av. Rancho El Chato a camino de los Reyes); ubicada en la localidad y Municipio de Tizayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N210/N210.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N210/JAN210.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N210/APN210.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N210/FAN210.pdf`,
                    },
                    ],
                },
        // Licitación N209
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N209-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Estudio y proyecto del sistema de agua potable en cabecera municipal;  ubicada en la localidad y Municipio de Pisaflores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N209/N209.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N209/JAN209.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N209/APN209.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N209/FAN209.pdf`,
                    },
                    ],
                },
        // Licitación N208
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N208-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de camino principal de Cuchilalpan a Ciénega Chica; ubicada en la localidad Cuchilalpan, Municipio de Omitlán de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N208/N208.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N208/JAN208.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N208/APN208.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N208/FAN208.pdf`,
                    },
                    ],
                },
        // Licitación N207
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N207-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de camino principal de Cerro Gordo; ubicada en la localidad de Cerro Gordo, Municipio de Omitlán de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N207/N207.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N207/JAN207.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N207/APN207.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N207/FAN207.pdf`,
                    },
                    ],
                },
        // Licitación N206
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N206-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de cancha de futbol rápido, en cabecera municipal en la unidad deportiva; ubicada en la localidad y Municipio San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N206/N206.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N206/JAN206.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N206/APN206.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N206/FAN206.pdf`,
                    },
                    ],
                },
        // Licitación N205
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N205-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calles en Téllez; ubicada en la localidad de Jagüey de Téllez (Estación Téllez), Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N205/N205.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N205/JAN205.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N205/APN205.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N205/FAN205.pdf`,
                    },
                    ],
                },
        // Licitación N204
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N204-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de empedrado. rehabilitación de terraplén e instalación de alumbrado público, en Prol. Pedro María Anaya, Col. Rojo Gómez; ubicada en la localidad y Municipio de Huichapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N204/N204.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N204/JAN204.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N204/APN204.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N204/FAN204.pdf`,
                    },
                    ],
                },
        // Licitación N203
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N203-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Sistema de alcantarillado Sabina Grande-Tinajas; ubicado en la localidad de Sabina Grande, Municipio de Huichapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N203/N203.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N203/JAN203.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N203/APN203.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N203/FAN203.pdf`,
                    },
                    ],
                },
        // Licitación N202
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N202-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación de asfalto Calvario-Capilla; ubicada en la localidad y Municipio de El Arenal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N202/N202.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N202/JAN202.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N202/APN202.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N202/FAN202.pdf`,
                    },
                    ],
                },
        // Licitación N201
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N201-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimento asfáltico en calle Emiliano Zapata; ubicada en la localidad y Municipio de El Arenal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N201/N201.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N201/JAN201.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N201/APN201.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N201/FAN201.pdf`,
                    },
                    ],
                },
        // Licitación N200
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N200-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica El Meje centro- Los Rosas; ubicada en la localidad de El Meje,  Municipio de El Arenal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N200/N200.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N200/JAN200.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N200/APN200.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N200/FAN200.pdf`,
                    },
                    ],
                },
        // Licitación N199
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N199-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de techado en plaza comunitaria Pisaflores; ubicada en la localidad y Municipio de Pisaflores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N199/N199.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N199/JAN199.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N199/APN199.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N199/FAN199.pdf`,
                    },
                    ],
                },
        // Licitación N198
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N198-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Rehabilitación de pavimento asfáltico en prolongación calle Jorge Rojo Lugo (acceso a unidad deportiva); ubicada en la localidad y Municipio de Huichapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N198/N198.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N198/JAN198.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N198/APN198.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N198/FAN198.pdf`,
                    },
                    ],
                },
        // Licitación N197
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N197-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Ampliación  de red eléctrica en calle de acceso al Telebachillerato El Rincón; ubicada en la localidad de El Rincón, Municipio de El Arenal, Estado de Hidalgo. ',
                    'urlAnexos' : `${ ligabase }29/N197/N197.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N197/JAN197.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N197/APN197.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N197/FAN197.pdf`,
                    },
                    ],
                },
        // Licitación N196
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N196-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de mercado municipal; ubicada en la localidad y Municipio de Singuilucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N196/N196.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N196/JAN196.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N196/APN196.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N196/FAN196.pdf`,
                    },
                    ],
                },
        // Licitación N195
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N195-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Rehabilitación de Plaza Juárez, 1 era etapa en cabecera municipal; ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N195/N195.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N195/JAN195.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N195/APN195.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }29/N195/AMDAPN195.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N195/FAN195.pdf`,
                    },
                    ],
                },
        // Licitación N194
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N194-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Modernización de camino El Rayo - Pisaflores; ubicada en la localidad de El Rayo, Municipio de Pisaflores,  Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N194/N194.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N194/JAN194.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N194/APN194.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N194/FAN194.pdf`,
                    },
                    ],
                },
        // Licitación N193
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N193-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción del C2 (Centro de Control y Comando y equipamiento de Seguridad Pública); ubicada en la localidad y Municipio de El Arenal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N193/N193.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N193/JAN193.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N193/APN193.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N193/FAN193.pdf`,
                    },
                    ],
                },
        // Licitación N192
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N192-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica Calle Libertad;  ubicada en la localidad de Progreso, Municipio de Progreso de Obregón, Estado de Hidalgo. (Segundo Procedimiento).',
                    'urlAnexos' : `${ ligabase }29/N192/N192.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N192/JAN192.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N192/APN192.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N192/FAN192.pdf`,
                    },
                    ],
                },
        // Licitación N191
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N191-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de octubre al 4 de noviembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de Pavimento hidráulico, guarniciones y banquetas en calle de Los Olivos;  ubicada en la localidad de Viveros de La Loma, Municipio de Tulancingo de Bravo, Estado de Hidalgo. (Segundo Procedimiento).',
                    'urlAnexos' : `${ ligabase }29/N191/N191.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }29/N191/JAN191.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }29/N191/APN191.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }29/N191/FAN191.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 028
            'numConvocatoria' : 'Convocatoria No. 028/2019.',
            'idConvocatoria' : 'Convocatoria28',
            'procedimientos' : [
        // Licitación N190
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N190-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 21 al 29 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica calle Chavarria Poniente, fracc. Haciendas de Tizayuca; ubicada en la localidad y Municipio de Tizayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N190/N190.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }28/N190/JAN190.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }28/N190/APN190.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }28/N190/FAN190.pdf`,
                    },
                    ],
                },
        // Licitación N189
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N189-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 21 al 29 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de la Unidad Basica de Rehabilitación UBR (terminación); ubicada en la localidad de Progreso, Municipio de Progreso de Obregón, Estado de Hidalgo. ',
                    'urlAnexos' : `${ ligabase }28/N189/N189.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }28/N189/JAN189.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }28/N189/APN189.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }28/N189/FAN189.pdf`,
                    },
                    ],
                },
        // Licitación N188
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N188-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 21 al 29 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de carpeta asfáltica de camino libramiento Camino Real -Tepeapulco  - Tlanalapa, 700 ml.; ubicada en la localidad y Municipio de Tlanalapa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N188/N188.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }28/N188/JAN188.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }28/N188/APN188.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }28/N188/FAN188.pdf`,
                    },
                    ],
                },
        // Licitación N187
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N187-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 21 al 29 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación de asfalto antigua vía del tren, San Pedro; ubicada en la localidad de Puerto San Pedro (Las Peñitas), Municipio de El Arenal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N187/N187.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }28/N187/JAN187.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }28/N187/APN187.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }28/N187/FAN187.pdf`,
                    },
                    ],
                },
        // Licitación N186
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N186-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 21 al 28 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en carretera Zothe La Cruz - Tlaxcalilla; ubicada en la localidad de Zothe, Municipio de Huichapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N186/N186.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }28/N186/JAN186.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }28/N186/APN186.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }28/N186/FAN186.pdf`,
                    },
                    ],
                },
        // Licitación N185
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N185-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 21 al 28 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica La Palma; ubicada en la localidad de Ojo de Agua San José Tepenene, Municipio de El Arenal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N185/N185.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }28/N185/JAN185.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }28/N185/APN185.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }28/N185/FAN185.pdf`,
                    },
                    ],
                },
        // Licitación N184
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N184-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 21 al 28 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica San Pedro; ubicada en la localidad de Ojo de Agua San José Tepenene, Municipio de El Arenal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N184/N184.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }28/N184/JAN184.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }28/N184/APN184.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }28/N184/FAN184.pdf`,
                    },
                    ],
                },
        // Licitación N183
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N183-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 21 al 28 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación con concreto hidráulico de calle Lic. Omar Fayad Meneses, col. Sales y Minerales; ubicada en la localidad y Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N183/N183.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }28/N183/JAN183.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }28/N183/APN183.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }28/N183/FAN183.pdf`,
                    },
                    ],
                },
        // Licitación N182
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N182-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 21 al 28 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calles Lindavista;  ubicada en la localidad de Linda Vista, Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N182/N182.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }28/N182/JAN182.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }28/N182/APN182.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }28/N182/FAN182.pdf`,
                    },
                    ],
                },
        // Licitación N181
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N181-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 21 al 28 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación de asfalto El Bocja - Centro; ubicada en la localidad de El Bocja, Municipio de El Arenal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N181/N181.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }28/N181/JAN181.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }28/N181/APN181.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }28/N181/FAN181.pdf`,
                    },
                    ],
                },
        // Licitación N180
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N180-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 21 al 28 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Rodadas en el acceso a la comunidad La Encarnación; ubicada en la localidad de Encarnación, Municipio de Zimapán, Estado de Hidalgo. (Segundo Procedimiento).',
                    'urlAnexos' : `${ ligabase }28/N180/N180.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }28/N180/JAN180.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }28/N180/APN180.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }28/N180/FAN180.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 026
            'numConvocatoria' : 'Convocatoria No. 026/2019.',
            'idConvocatoria' : 'Convocatoria26',
            'procedimientos' : [
        // Licitación N178
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N178-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción del sistema de alcantarillado sanitario (zona sur), para beneficiar a la localidad de Boxaxni en el municipio de San Salvador;  ubicada en la localidad de Boxaxni, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N178/N178.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N178/JAN178.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N178/APN178.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N178/FAN178.pdf`,
                    },
                    ],
                },
        // Licitación N177
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N177-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Lolotla;  ubicada en varias localidades, Municipio de Lolotla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N177/N177.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N177/JAN177.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N177/APN177.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N177/FAN177.pdf`,
                    },
                    ],
                },
        // Licitación N176
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N176-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Huazalingo;  ubicada en varias localidades, Municipio de Huazalingo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N176/N176.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N176/JAN176.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N176/APN176.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N176/FAN176.pdf`,
                    },
                    ],
                },
        // Licitación N175
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N175-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción del sistema de alcantarillado sanitario (zona este), para beneficiar a la localidad de El Aguacatito, en el municipio de Zimapán;  ubicada en la localidad de El Aguacatito, Municipio de Zimapán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N175/N175.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N175/JAN175.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N175/APN175.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N175/FAN175.pdf`,
                    },
                    ],
                },
        // Licitación N174
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N174-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Zempoala;  ubicada en la Localidad de Zempoala, Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N174/N174.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N174/JAN174.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N174/APN174.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N174/FAN174.pdf`,
                    },
                    ],
                },
        // Licitación N173
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N173-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Tlahuiltepa;  ubicada en varias localidades, Municipio de Tlahuiltepa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N173/N173.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N173/JAN173.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N173/APN173.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N173/FAN173.pdf`,
                    },
                    ],
                },
        // Licitación N172
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N172-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Estudio y proyecto para la construcción  del puente vehicular para conectar Santa Ana Ahuehuepan, comunidad El Chivo;  ubicada en la localidad de Santa Ana Ahuehuepan, Municipio de Tula de Allende, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N172/N172.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N172/JAN172.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N172/APN172.pdf`,
                    },
                    ],
                },
        // Licitación N171
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N171-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de edificio público para beneficiar a la localidad de San Francisco;  ubicada en la localidad de San Francisco, Municipio de Huazalingo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N171/N171.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N171/JAN171.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N171/APN171.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N171/FAN171.pdf`,
                    },
                    ],
                },
        // Licitación N170
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N170-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Instalación de sistema interconectado para bombeo de agua potable;  ubicada en la localidad de Río Seco Puente de Doria, Municipio de Huasca de Ocampo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N170/N170.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N170/JAN170.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N170/APN170.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N170/FAN170.pdf`,
                    },
                    ],
                },
        // Licitación N169
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N169-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de módulo de orientación, rehabilitación de instalaciones y obra exterior en Centro de Educación Media Superior a Distancia plantel Julián Villagrán C.C.T. 13EMS0089V;  ubicada en la localidad de Julián Villagran, Loma Centro, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N169/N169.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N169/JAN169.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N169/APN169.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N169/FAN169.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 025
            'numConvocatoria' : 'Convocatoria No. 025/2019.',
            'idConvocatoria' : 'Convocatoria25',
            'procedimientos' : [
        // Licitación N168
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N168-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de distribuidor vial en el entronque del  Boulevard Luis D. Colosio  y el Boulevard  Ramón G. Bonfil, segunda etapa; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N168/N168.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N168/JAN168.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N168/APN168.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N168/FAN168.pdf`,
                    },
                    ],
                },
        // Licitación N167
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N167-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de albañilerías, cancelería e instalaciones del Polideportivo PLATAH;  ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N167/N167.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N167/JAN167.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N167/APN167.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N167/FAN167.pdf`,
                    },
                    ],
                },
        // Licitación N166
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N166-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de techado en espacio deportivo en cabecera municipal;  ubicada en la localidad y Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N166/N166.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N166/JAN166.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N166/APN166.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N166/FAN166.pdf`,
                    },
                    ],
                },
        // Licitación N165
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N165-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Techumbre en Escuela Primaria Escuadrón Aéreo 201;  ubicada en la localidad de La Puerta, Municipio de Francisco I. Madero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N165/N165.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N165/JAN165.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N165/APN165.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N165/FAN165.pdf`,
                    },
                    ],
                },
        // Licitación N164
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N164-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Red de drenaje sanitario en el Fraccionamiento San Juan Tizahuapan;  ubicada en la localidad de  San Juan Tizahuapan, Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N164/N164.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N164/JAN164.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N164/APN164.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N164/FAN164.pdf`,
                    },
                    ],
                },
        // Licitación N163
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N163-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica calle Javier Hernández Hdez.;  ubicada en la localidad de Progreso, Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N163/N163.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N163/JAN163.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N163/APN163.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N163/FAN163.pdf`,
                    },
                    ],
                },
        // Licitación N162
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N162-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Reconstrucción con carpeta asfáltica C.E. Zimapán-Detzanhi;  ubicada en la localidad de Benito Juárez (Detzani), Municipio de Zimapán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N162/N162.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N162/JAN162.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N162/APN162.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N162/FAN162.pdf`,
                    },
                    ],
                },
        // Licitación N161
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N161-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de drenaje sanitario;  ubicada en la localidad de La Cruz de Piedra, Municipio de Tecozautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N161/N161.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N161/JAN161.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N161/APN161.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N161/FAN161.pdf`,
                    },
                    ],
                },
        // Licitación N160
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N160-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de arcotecho en la Escuela Primaria Lázaro Cárdenas; ubicada en la localidad  de Tepeji de Ocampo,  Municipio de Tepeji del Río de Ocampo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N160/N160.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N160/JAN160.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N160/APN160.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N160/FAN160.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 024
            'numConvocatoria' : 'Convocatoria No. 024/2019.',
            'idConvocatoria' : 'Convocatoria24',
            'procedimientos' : [
        // Licitación N159
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N159-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Acondicionamiento de patio cívico y/o deportivo en la Primaria Gral. Julián Villagrán; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N159/N159.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N159/JAN159.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N159/APN159.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N159/FAN159.pdf`,
                    },
                    ],
                },
        // Licitación N158
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N158-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de la calle Porfirio Díaz, colonia La Loma; ubicada en la localidad de La Loma, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N158/N158.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N158/JAN158.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N158/APN158.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N158/FAN158.pdf`,
                    },
                    ],
                },
        // Licitación N157
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N157-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica calle Benito Juárez Col. Cerrito Colorado; ubicada en la localidad de Progreso, Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N157/N157.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N157/JAN157.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N157/APN157.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N157/FAN157.pdf`,
                    },
                    ],
                },
        // Licitación N156
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N156-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de la calle Río Celaya, Ampliación El Palmar; ubicada en varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N156/N156.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N156/JAN156.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N156/APN156.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N156/FAN156.pdf`,
                    },
                    ],
                },
        // Licitación N155
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N155-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de guarniciones y banquetas Botenguedho; ubicada en la localidad de Botenguedho, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N155/N155.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N155/JAN155.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N155/APN155.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N155/FAN155.pdf`,
                    },
                    ],
                },
        // Licitación N154
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N154-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Degantzá, colonia de Sacramontes; ubicada en la localidad de San José Boxay, Municipio de Francisco I. Madero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N154/N154.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N154/JAN154.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N154/APN154.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N154/FAN154.pdf`,
                    },
                    ],
                },
        // Licitación N153
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N153-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de la calle Oaxaca en la colonia Loma Bonita; ubicada en la localidad de Ampliación Loma Bonita, Municipio de Apan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N153/N153.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N153/JAN153.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N153/APN153.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N153/FAN153.pdf`,
                    },
                    ],
                },
        // Licitación N152
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N152-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Drenaje sanitario en calle principal, Nuevo San Bartolo; ubicada en la localidad de San Bartolo (Ejido Villa Aquiles Serdán), Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N152/N152.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N152/JAN152.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N152/APN152.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N152/FAN152.pdf`,
                    },
                    ],
                },
        // Licitación N151
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N151-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 14 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de la calle Avenida del Trabajo; ubicada en la localidad de Zotoluca (Veloz), Municipio de Apan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N151/N151.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N151/JAN151.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N151/APN151.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N151/FAN151.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 023
            'numConvocatoria' : 'Convocatoria No. 023/2019.',
            'idConvocatoria' : 'Convocatoria23',
            'procedimientos' : [
        // Licitación N150
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N150-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : '1ra. Etapa del techado en patio cívico José Joaquín Fernández de Lizardi clave: 13DJNO794I; ubicada en la localidad de San Antonio, Municipio de Atotonilco de Tula, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N150/N150.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N150/JAN150.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N150/APN150.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N150/FAN150.pdf`,
                    },
                    ],
                },
        // Licitación N149
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N149-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de cancha de fútbol rápido; ubicada en la localidad y Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N149/N149.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N149/JAN149.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N149/APN149.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N149/FAN149.pdf`,
                    },
                    ],
                },
        // Licitación N148
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N148-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de calles y/o andadores; ubicada en la localidad de San Cristóbal, Municipio de La Misión, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N148/N148.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N148/JAN148.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N148/APN148.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N148/FAN148.pdf`,
                    },
                    ],
                },
        // Licitación N147
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N147-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica calle Ingenieros Civiles, en la Col. Emiliano Zapata; ubicada en la localidad de Santiago Tulantepcc, Municipio de Santiago Tulantepec de Lugo Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N147/N147.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N147/JAN147.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N147/APN147.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N147/FAN147.pdf`,
                    },
                    ],
                },
        // Licitación N146
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N146-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico, andador Krystal; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo .',
                    'urlAnexos' : `${ ligabase }23/N146/N146.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N146/JAN146.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N146/APN146.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N146/FAN146.pdf`,
                    },
                    ],
                },
        // Licitación N145
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N145-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica calle Matamoros, en la comunidad El Cerrito; ubicada en la localidad de El Cerrito, Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N145/N145.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N145/JAN145.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N145/APN145.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N145/FAN145.pdf`,
                    },
                    ],
                },
        // Licitación N144
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N144-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de la calle Juárez, colonia El Rosario; ubicada en la localidad de El Rosario, Municipio de Francisco I. Madero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N144/N144.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N144/JAN144.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N144/APN144.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N144/FAN144.pdf`,
                    },
                    ],
                },
        // Licitación N143
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N143-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica calle Avenida Revolución en la comunidad Villa Margarita; ubicada en la localidad de Villa Margarita, Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N143/N143.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N143/JAN143.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N143/APN143.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N143/FAN143.pdf`,
                    },
                    ],
                },
        // Licitación N142
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N142-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Sistema de distribución de agua potable en la Colonia Cañada 2da. Sección; ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N142/N142.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N142/JAN142.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N142/APN142.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N142/FAN142.pdf`,
                    },
                    ],
                },
        // Licitación N141
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N141-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Pino Suárez; ubicada en la localidad de San Gabriel Azteca, Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N141/N141.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N141/JAN141.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N141/APN141.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N141/FAN141.pdf`,
                    },
                    ],
                },
            ],
    },    	
    {
        // CONVOCATORIA NUM# 022
            'numConvocatoria' : 'Convocatoria No. 022/2019.',
            'idConvocatoria' : 'Convocatoria22',
            'procedimientos' : [
        // Licitación N140
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N140-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Rehabilitación de vialidades primarias en el municipio de Pachuca; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N140/N140.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N140/JAN140.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N140/APN140.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N140/FAN140.pdf`,
                    },
                    ],
                },
        // Licitación N139
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N139-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Modernización Blvd. Ramón G. Bonfil, subtramo del Km 1+740 (E.C. Blvd. Real de la Plata) al Km 4+780 (SNTE), dos cuerpos; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N139/N139.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N139/JAN139.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N139/APN139.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }22/N139/AMDAPN139.pdf`,
                    },
                    ],
                },
        // Licitación N138
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N138-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Perforación exploratoria de pozo profundo para beneficiar a la localidad de Chantasco, municipio de Lolotla; ubicada en la localidad de Chantasco, Municipio de Lolotla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N138/N138.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N138/JAN138.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N138/APN138.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N138/FAN138.pdf`,
                    },
                    ],
                },
        // Licitación N137
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N137-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción del sistema de alcantarillado sanitario, para beneficiar a la localidad de González González, en el municipio de Santiago de Anaya; ubicada en la localidad de González González, Municipio de Santiago de Anaya, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N137/N137.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N137/JAN137.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N137/APN137.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N137/FAN137.pdf`,
                    },
                    ],
                },
        // Licitación N136
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N136-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de sala para la extracción de miel de abeja en la localidad de Zacapilol, municipio de San Felipe Orizatlán; ubicada en la localidad Zacapilol, Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N136/N136.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N136/JAN136.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N136/APN136.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N136/FAN136.pdf`,
                    },
                    ],
                },
        // Licitación N135
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N135-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de sala para la extracción de miel de abeja en la localidad de San Cristóbal, en el municipio de Tlanchinol; ubicada en la localidad de San Cristóbal (San Cristóbal Ajacayac), Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N135/N135.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N135/JAN135.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N135/APN135.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N135/FAN135.pdf`,
                    },
                    ],
                },
        // Licitación N134
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N134-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de circuito en San Andrés Orizabita; ubicada en la localidad de Orizabita, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N134/N134.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N134/JAN134.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N134/APN134.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }22/N134/AMDAPN134.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N134/FAN134.pdf`,
                    },
                    ],
                },
        // Licitación N133
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N133-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de techado de cancha de usos múltiples en Esc. Telesecundaria No. 495 Iglesia Vieja; ubicada en la localidad de Iglesia Vieja, Municipio de Chapulhuacán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N133/N133.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N133/JAN133.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N133/APN133.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }22/N133/AMDAPN133.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N133/FAN133.pdf`,
                    },
                    ],
                },
        // Licitación N132
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N132-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de comedor en Escuela Secundaria Javier Rojo Gómez CCT 13DES0027A; ubicada en la localidad de Santa María Amajac, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N132/N132.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N132/JAN132.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N132/APN132.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }22/N132/AMDAPN132.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N132/FAN132.pdf`,
                    },
                    ],
                },
        // Licitación N131
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N131-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de la red de drenaje sanitario en la calle principal, en la localidad de San Mateo; ubicada en la localidad de San Mateo, Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N131/N131.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N131/JAN131.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N131/APN131.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }22/N131/AMDAPN131.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N131/FAN131.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 021
            'numConvocatoria' : 'Convocatoria No. 021/2019.',
            'idConvocatoria' : 'Convocatoria21',
            'procedimientos' : [
        // Licitación N130
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N130-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Centro de Desarrollo Cd. Sahagún; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N130/N130.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N130/JAN130.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N130/APN130.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N130/FAN130.pdf`,
                    },
                    ],
                },
        // Licitación N129
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N129-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de dos aulas en Telebachillerato Comunitario de Cuamontax, clave 13ETK013OM;  ubicada en la localidad de Cuamontax, Municipio de Huazalingo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N129/N129.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N129/JAN129.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N129/APN129.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N129/FAN129.pdf`,
                    },
                    ],
                },
        // Licitación N128
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N128-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en calle Milenio; ubicada en la localidad de Ignacio López Rayón, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N128/N128.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N128/JAN128.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N128/APN128.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N128/FAN128.pdf`,
                    },
                    ],
                },
        // Licitación N127
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N127-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de calle Martín Lutero;  ubicada en la localidad de El Durazno, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N127/N127.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N127/JAN127.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N127/APN127.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N127/FAN127.pdf`,
                    },
                    ],
                },
        // Licitación N126
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N126-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación Hidráulica, red de drenaje sanitario, red de agua potable y guarniciones en la calle Palma;  ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N126/N126.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N126/JAN126.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N126/APN126.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N126/FAN126.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }21/N126/AMDFAN126.pdf`,
                    },
                    ],
                },
        // Licitación N125
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N125-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Techumbre en la Secundaria de la Loc. de Chalma;  ubicada en la localidad de Chalma, Municipio de Lolotla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N125/N125.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N125/JAN125.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N125/APN125.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N125/FAN125.pdf`,
                    },
                    ],
                },
        // Licitación N124
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N124-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de puente peatonal, en la localidad de Las Fuentes;  ubicada en la localidad de Singuilucan, Municipio de Singuilucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N124/N124.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N124/JAN124.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N124/APN124.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N124/FAN124.pdf`,
                    },
                    ],
                },
        // Licitación N123
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N123-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación en la Col. La Rivera, calle La Ceiba y calle sin nombre. Cabecera Municipal; ubicada en la localidad de Orizatlán, Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N123/N123.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N123/JAN123.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N123/APN123.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N123/FAN123.pdf`,
                    },
                    ],
                },
        // Licitación N122
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N122-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica, red de drenaje, sanitario, red de agua potable y guarniciones en Av. Valle Dorado y pavimentación hidráulica calle Valle de Plata en Col. Valles de Pachuca;  ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N122/N122.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N122/JAN122.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N122/APN122.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N122/FAN122.pdf`,
                    },
                    ],
                },
        // Licitación N121
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N121-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 9 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico en la calle sin nombre;  ubicada en la localidad de San Pedro Nopancalco, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N121/N121.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N121/JAN121.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N121/APN121.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N121/FAN121.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 020
            'numConvocatoria' : 'Convocatoria No. 020/2019.',
            'idConvocatoria' : 'Convocatoria20',
            'procedimientos' : [
        // Licitación N120
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N120-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico de calle Morelos;  ubicada en la localidad de El Barrido, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N120/N120.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N120/JAN120.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }20/N120/AMDJAN120.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N120/APN120.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N120/FAN120.pdf`,
                    },
                    ],
                },
        // Licitación N119
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N119-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimento de concreto hidráulico acceso principal;  ubicada en la localidad de La Libertad, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N119/N119.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N119/JAN119.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N119/APN119.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N119/FAN119.pdf`,
                    },
                    ],
                },
        // Licitación N118
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N118-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Techado de espacio deportivo en Escuela Primaria Indigena "Cuauhtémoc", C.C.T. 13DPR0836H en Tepetitla;  ubicada en la localidad de Tepetitla, Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N118/N118.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N118/JAN118.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N118/APN118.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N118/FAN118.pdf`,
                    },
                    ],
                },
        // Licitación N117
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N117-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle Josefa Ortíz de Domínguez, Ignacio Allende, Vicente Guerrero en col. 15 de Septiembre;  ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N117/N117.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N117/JAN117.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N117/APN117.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N117/FAN117.pdf`,
                    },
                    ],
                },
        // Licitación N116
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N116-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de techumbre en la escuela bilingüe Adolfo Ruiz Cortines, clave C.C.T. 13DPBO5122 de Huacaxtitla;  ubicada en la localidad de  Huacaxtitla, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N116/N116.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N116/JAN116.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N116/APN116.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N116/FAN116.pdf`,
                    },
                    ],
                },
        // Licitación N115
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N115-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de techumbre en la Escuela Secundaria Técnica no. 36 Ignacio Zaragoza, clave 13DST0036A de Ixcatlán;  ubicada en la localidad de  Ixcatlán, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N115/N115.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N115/JAN115.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N115/APN115.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N115/FAN115.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }20/N115/AMDFAN115.pdf`,
                    },
                    ],
                },
        // Licitación N114
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N114-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Techumbre de la Escuela Primaria Salomón Reyes;  ubicada en la localidad de Venustiano Carranza, Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N114/N114.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N114/JAN114.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N114/APN114.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N114/FAN114.pdf`,
                    },
                    ],
                },
        // Licitación N113
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N113-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Trabajos complementarios deportivo colonia Benito Juárez; ubicada en la localidad Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N113/N113.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N113/JAN113.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N113/APN113.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N113/FAN113.pdf`,
                    },
                    ],
                },
        // Licitación N112
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N112-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción del Centro de Rehabilitación Infantil Comunitaria CAIC;  ubicada en la localidad de Santiago Tulantepec, Municipio de Santiago Tulantepec de Lugo Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N112/N112.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N112/JAN112.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N112/APN112.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N112/FAN112.pdf`,
                    },
                    ],
                },
        // Licitación N111
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N111-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Rehabilitación de pavimento asfáltico en el mercado municipal; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N111/N111.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N111/JAN111.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N111/APN111.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N111/FAN111.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 019
            'numConvocatoria' : 'Convocatoria No. 019/2019.',
            'idConvocatoria' : 'Convocatoria19',
            'procedimientos' : [
        // Licitación N110
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N110-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimento asfáltico de calles del mercado;  ubicada en la localidad Fray Bernardino de Sahagún, Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N110/N110.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N110/JAN110.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N110/APN110.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N110/FAN110.pdf`,
                    },
                    ],
                },
        // Licitación N109
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N109-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación de calle;  ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. ',
                    'urlAnexos' : `${ ligabase }19/N109/N109.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N109/JAN109.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N109/APN109.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N109/FAN109.pdf`,
                    },
                    ],
                },
        // Licitación N108
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N108-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica Calle Rosales-Oyamel-Jazmines;  ubicada en la localidad de Progreso, Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N108/N108.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N108/JAN108.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N108/APN108.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N108/FAN108.pdf`,
                    },
                    ],
                },
        // Licitación N107
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N107-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica Calle Libertad;  ubicada en la localidad de Progreso, Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N107/N107.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N107/JAN107.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N107/APN107.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N107/FAN107.pdf`,
                    },
                    ],
                },
        // Licitación N106
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N106-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Rehabilitación de pavimentación de asfálto en calle José Murillo Hamed;  ubicada en varias localidades, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N106/N106.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N106/JAN106.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N106/APN106.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N106/FAN106.pdf`,
                    },
                    ],
                },
        // Licitación N105
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N105-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Reconstrucción de pavimento en calle Ignacio Zaragoza de la colonia Benito Juárez;  ubicada en la localidad de  Benito Juárez, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N105/N105.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N105/JAN105.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N105/APN105.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N105/FAN105.pdf`,
                    },
                    ],
                },
        // Licitación N104
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N104-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica Calle Venus;  ubicada en la localidad de Carboneras, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N104/N104.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N104/JAN104.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N104/APN104.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N104/FAN104.pdf`,
                    },
                    ],
                },
        // Licitación N103
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N103-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación Hidráulica calle 12 de Octubre;  ubicada en la localidad de Xochitlan, Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N103/N103.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N103/JAN103.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N103/APN103.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N103/FAN103.pdf`,
                    },
                    ],
                },
        // Licitación N102
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N102-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Rehabilitación de mercado municipal de Mixquiahuala de Juárez;  ubicada en la localidad y Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N102/N102.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N102/JAN102.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N102/APN102.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N102/FAN102.pdf`,
                    },
                    ],
                },
        // Licitación N101
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N101-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación Hidráulica calle Ferrocarril Norte;  ubicada en la localidad y Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N101/N101.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N101/JAN101.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N101/APN101.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N101/FAN101.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 018
            'numConvocatoria' : 'Convocatoria No. 018/2019.',
            'idConvocatoria' : 'Convocatoria18',
            'procedimientos' : [
        // Licitación N100
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N100-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Techumbre en Escuela Primaria Emiliano Zapata;  ubicada en la localidad de San Antonio Oxtoyucan, Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N100/N100.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N100/JAN100.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N100/APN100.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }18/N100/AMDAPN100.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N100/FAN100.pdf`,
                    },
                    ],
                },
        // Licitación N99
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N99-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Reencarpetamiento asfáltico de la calle Revolución;  ubicada en la localidad de Xochitlan,  Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N99/N99.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N99/JAN99.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N99/APN99.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N99/FAN99.pdf`,
                    },
                    ],
                },
        // Licitación N98
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N98-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Drenaje sanitario y pavimentación hidráulica de calle Porfirio Díaz, Cerro de Guadalupe, colonia La Palma;  ubicada en la localidad de Col. La Palma, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N98/N98.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N98/JAN98.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N98/APN98.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N98/FAN98.pdf`,
                    },
                    ],
                },
        // Licitación N97
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N97-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Reconstrucción de pavimento asfáltico, en calle principal del Calvario;  ubicada en la localidad de Taxhuada, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N97/N97.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N97/JAN97.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N97/APN97.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N97/FAN97.pdf`,
                    },
                    ],
                },
        // Licitación N96
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N96-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de Pavimento hidráulico, guarniciones y banquetas en calle de Los Olivos;  ubicada en la localidad de Viveros de La Loma, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N96/N96.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N96/JAN96.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N96/APN96.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N96/FAN96.pdf`,
                    },
                    ],
                },
        // Licitación N95
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N95-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica calle 24 de Febrero;  ubicada en la localidad de Xochitlan, Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N95/N95.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N95/JAN95.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N95/APN95.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N95/FAN95.pdf`,
                    },
                    ],
                },
        // Licitación N94
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N94-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Perforación de pozo, equipamiento y tanque elevado de la comunidad El Moreno; ubicada en la localidad de San Miguel El Moreno, Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N94/N94.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N94/JAN94.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N94/APN94.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N94/FAN94.pdf`,
                    },
                    ],
                },
        // Licitación N93
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N93-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación del camino a Coatlila primera etapa;  ubicada en la localidad de Coatlila, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N93/N93.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N93/JAN93.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N93/APN93.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N93/FAN93.pdf`,
                    },
                    ],
                },
        // Licitación N92
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N92-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimento asfáltico, acceso col. 3 de Mayo;  ubicada en la localidad de Taxhuada, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N92/N92.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N92/JAN92.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N92/APN92.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N92/FAN92.pdf`,
                    },
                    ],
                },
        // Licitación N91
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N91-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de septiembre al 7 de octubre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de auditorio en Téllez;  ubicada en la localidad Jaguey de Téllez (Estación de Téllez), Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N91/N91.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N91/JAN91.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N91/APN91.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N91/FAN91.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 017
            'numConvocatoria' : 'Convocatoria No. 017/2019.',
            'idConvocatoria' : 'Convocatoria17',
            'procedimientos' : [
        // Licitación N90
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N90-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Rehabilitación de vialidades en diversos municipios; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }17/N90/N90.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N90/JAN90.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N90/APN90.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N90/FAN90.pdf`,
                    },
                    ],
                },
        // Licitación N89
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N89-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Reconstrucción de pavimento asfáltico acceso a Cuatlaco; ubicada en la localidad de Cuatlaco, Municipio de Almoloya, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N89/N89.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N89/JAN89.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N89/APN89.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N89/FAN89.pdf`,
                    },
                    ],
                },
        // Licitación N88
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N88-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Reconstrucción de pavimento asfáltico en carretera Rancho Nuevo-Las Vigas; ubicada en la localidad de Las Vigas, Municipio de Almoloya, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N88/N88.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N88/JAN88.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N88/APN88.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N88/FAN88.pdf`,
                    },
                    ],
                },
        // Licitación N87
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N87-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de carpeta asfáltica del par vial de Acatlán, tramo: Tulancingo-Acatlán, 1.60 Km; ubicada en la localidad y Municipio de Acatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N87/N87.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N87/JAN87.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N87/APN87.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N87/FAN87.pdf`,
                    },
                    ],
                },
        // Licitación N86
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N86-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica, calle Xochiquetzali, tramo calle Toltecas - calle Quetzalcóatl; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N86/N86.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N86/JAN86.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N86/APN86.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N86/FAN86.pdf`,
                    },
                    ],
                },
        // Licitación N85
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N85-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación con concreto hidráulico calle Margarita Maza de Juárez, tramo: calle Juan de la Barrera - calle Cerro del Arco; ubicada en la localidad de Santiago Tlapacoya, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N85/N85.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N85/JAN85.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N85/APN85.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N85/FAN85.pdf`,
                    },
                    ],
                },
        // Licitación N84
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N84-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico de calle Francisco Villa barrio de Jesús, 1ra etapa; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N84/N84.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N84/JAN84.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N84/APN84.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N84/FAN84.pdf`,
                    },
                    ],
                },
        // Licitación N83
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N83-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de patio cívico y techumbre de la Universidad de la Sierra Hidalguense; ubicada en la localidad y Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N83/N83.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N83/JAN83.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N83/APN83.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N83/FAN83.pdf`,
                    },
                    ],
                },
        // Licitación N82
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N82-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de patio cívico y techumbre del telebachillerato de Tenango; ubicada en la localidad de Tenango, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N82/N82.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N82/JAN82.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N82/APN82.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N82/FAN82.pdf`,
                    },
                    ],
                },
        // Licitación N81
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N81-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de patio cívico y techumbre del COBAEH; ubicada en la localidad de Acoxcatlán, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N81/N81.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N81/JAN81.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N81/APN81.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N81/FAN81.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 016
            'numConvocatoria' : 'Convocatoria No. 016/2019.',
            'idConvocatoria' : 'Convocatoria16',
            'procedimientos' : [
        // Licitación N80
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N80-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'CECYTE Plantel Atotonilco de Tula; ubicada en la localidad de Ocampo, Municipio de Atotonilco de Tula, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N80/N80.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N80/JAN80.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N80/APN80.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N80/FAN80.pdf`,
                    },
                    ],
                },
        // Licitación N79
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N79-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Reconstrucción de techumbre (arcotecho) en mercado Tepeapulco; ubicada en la localidad y Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N79/N79.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N79/JAN79.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N79/APN79.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N79/FAN79.pdf`,
                    },
                    ],
                },
        // Licitación N78
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N78-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de San Esteban-Palo Verde; ubicada en la localidad de San Esteban, Municipio de Huehuetla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N78/N78.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N78/JAN78.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N78/APN78.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N78/FAN78.pdf`,
                    },
                    ],
                },
        // Licitación N77
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N77-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de la calle Gardenia en la colonia Ampliación Rojo Gómez; ubicada en la localidad Javier Rojo Gómez, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N77/N77.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N77/JAN77.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N77/APN77.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N77/FAN77.pdf`,
                    },
                    ],
                },
        // Licitación N76
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N76-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle de acceso al Jardín de Niños Colibrí; ubicada en la localidad de Milpillas, Municipio de San Agustín Metzquititlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N76/N76.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N76/JAN76.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N76/APN76.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N76/FAN76.pdf`,
                    },
                    ],
                },
        // Licitación N75
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N75-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Rodadas en el acceso a la comunidad La Encarnación; ubicada en la localidad de Encarnación, Municipio de Zimapán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N75/N75.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N75/JAN75.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N75/APN75.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N75/FAN75.pdf`,
                    },
                    ],
                },
        // Licitación N74
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N74-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimento asfaltico, en calle 20 de Noviembre; ubicada en la localidad de Taxhuada, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N74/N74.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N74/JAN74.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N74/APN74.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N74/FAN74.pdf`,
                    },
                    ],
                },
        // Licitación N73
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N73-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de acceso a Hacienda Vieja; ubicada en la localidad de Benito Juárez, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N73/N73.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N73/JAN73.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N73/APN73.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N73/FAN73.pdf`,
                    },
                    ],
                },
        // Licitación N72
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N72-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica carretera al Relleno Sanitario Huixmi tramo calle 1o. de Mayo - Relleno Sanitario; ubicada en la localidad de Huixmi, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N72/N72.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N72/JAN72.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N72/APN72.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N72/FAN72.pdf`,
                    },
                    ],
                },
        // Licitación N71
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N71-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Modernización y Ampliación del camino San Felipe Orizatlán - Talapiz I - Talapiz II - Talol - La Pimienta - Xaltipa (municipio de San Felipe Orizatlán) - San José (municipio de Tlanchinol), tramo del Km 0+000 Al Km 25+000, Subtramo a modernizar del Km 5+350 al Km 6+284.22; ubicada en varias localidades del Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N71/N71.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N71/JAN71.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }16/N71/AMDJAN71.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N71/APN71.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N71/FAN71.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 015
            'numConvocatoria' : 'Convocatoria No. 015/2019.',
            'idConvocatoria' : 'Convocatoria15',
            'procedimientos' : [
        // Licitación N70
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N70-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Cereso Tula de Allende, ubicada en la localidad y Municipio de Tula de Allende, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N70/N70.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N70/JAN70.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N70/APN70.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }15/N70/AMDAPN70.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N70/FAN70.pdf`,
                    },
                    ],
                },
        // Licitación N69
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N69-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Secretaría de Seguridad Pública (módulo especial), ubicada en la localidad de Campo de Tiro, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N69/N69.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N69/JAN69.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N69/APN69.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }15/N69/AMDAPN69.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N69/FAN69.pdf`,
                    },
                    ],
                },
        // Licitación N68
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N68-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Cereso Jaltocán, ubicada en la localidad de La Lima, Municipio de Jaltocán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N68/N68.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N68/JAN68.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N68/APN68.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N68/FAN68.pdf`,
                    },
                    ],
                },
        // Licitación N67
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N67-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Centro de identificación humana para resguardo temporal de Hidalgo; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }15/N67/N67.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N67/JAN67.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N67/APN67.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N67/FAN67.pdf`,
                    },
                    ],
                },
        // Licitación N66
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N66-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Rehabilitación de la imagen urbana. Centro Histórico de Omitlán;  ubicada en la localidad y Municipio de Omitlán de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N66/N66.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N66/JAN66.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N66/APN66.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N66/FAN66.pdf`,
                    },
                    ],
                },
        // Licitación N65
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N65-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica (E.C. Ixmiquilpan - Cardonal Km 5.8 L.D.) - Cerritos - Camino Real del Km 0+000 al 0+950; ubicada en la localidad de Cerritos, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N65/N65.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N65/JAN65.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N65/APN65.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N65/FAN65.pdf`,
                    },
                    ],
                },
        // Licitación N64
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N64-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación Asfáltica de calle Las Curvas, Cantinela; ubicada en la localidad de Cantinela, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N64/N64.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N64/JAN64.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N64/APN64.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N64/FAN64.pdf`,
                    },
                    ],
                },
        // Licitación N63
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N63-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico, calle 28 de Octubre, tramo: calle sin nombre - calle 24 de Febrero; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N63/N63.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N63/JAN63.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N63/APN63.pdf`,
                    },
                    ],
                },
        // Licitación N62
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N62-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de calle de concreto hidráulico en la comunidad del Carmen calle Margarita sin número, Ixmiquilpan Hidalgo; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N62/N62.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N62/JAN62.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N62/APN62.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N62/FAN62.pdf`,
                    },
                    ],
                },
        // Licitación N61
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N61-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimento asfáltico camino de acceso a Santa Mónica Autempa E.C. (Pachuca-Huejutla), del Km 1+245 Al Km 1+920; ubicada en la localidad de Santa Mónica Autempa, Municipio de Metztitlan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N61/N61.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N61/JAN61.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N61/APN61.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N61/FAN61.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 014
            'numConvocatoria' : 'Convocatoria No. 014/2019.',
            'idConvocatoria' : 'Convocatoria14',
            'procedimientos' : [
        // Licitación N60
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N60-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 24 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico, guarniciones y banquetas en calle Jacarandas, de calle Eucalipto a calle de Álamo; ubicada en la localidad de Viveros de La Loma, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N60/N60.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N60/JAN60.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N60/APN60.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N60/FAN60.pdf`,
                    },
                    ],
                },
        // Licitación N59
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N59-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 24 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación en varias calles de col. Bugambilias; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N59/N59.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N59/JAN59.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N59/APN59.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N59/FAN59.pdf`,
                    },
                    ],
                },
        // Licitación N58
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N58-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 24 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Línea de conducción de tanque central al tanque de Villas de la Cañada; ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N58/N58.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N58/JAN58.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N58/APN58.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N58/FAN58.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 013
            'numConvocatoria' : 'Convocatoria No. 013/2019.',
            'idConvocatoria' : 'Convocatoria13',
            'procedimientos' : [
        // Licitación N57
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N57-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 17 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de muro de contención en prolongación del Andador Turístico Quetzalcóatl. En Tula de Allende, Hgo. ubicada en la localidad y Municipio de Tula de Allende, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }13/N57/N57.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N57/JAN57.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N57/APN57.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N57/FAN57.pdf`,
                    },
                    ],
                },
        // Licitación N56
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N56-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 17 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de banquetas en el Centro Histórico de Zempoala; ubicada en la localidad y Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }13/N56/N56.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N56/JAN56.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N56/APN56.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N56/FAN56.pdf`,
                    },
                    ],
                },
        // Licitación N55
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N55-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 17 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de techumbre en cancha deportiva en la escuela primaria "Mariano Matamoros"; ubicada en la localidad de San Nicolás El Xathe, Municipio de Atotonilco El Grande, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }13/N55/N55.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N55/JAN55.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N55/APN55.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N55/FAN55.pdf`,
                    },
                    ],
                },
        // Licitación N54
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N54-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 17 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación con empedrado y muro de contención en El Alberto; ubicada en la localidad de El Alberto, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }13/N54/N54.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N54/JAN54.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N54/APN54.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N54/FAN54.pdf`,
                    },
                    ],
                },
        // Licitación N53
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N53-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 17 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de la segunda etapa de la pavimentación del camino Teñhe-Cañada; ubicada en la localidad de Teñhe, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }13/N53/N53.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N53/JAN53.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N53/APN53.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N53/FAN53.pdf`,
                    },
                    ],
                },
        // Licitación N52
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N52-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 17 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Trabajos complementarios de la construcción de drenaje sanitario en varias localidades del municipio de Singuilucan; ubicada en la localidad y Municipio de Singuilucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }13/N52/N52.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N52/JAN52.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N52/APN52.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N52/FAN52.pdf`,
                    },
                    ],
                },
        // Licitación N51
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N51-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 17 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación, guarniciones y banquetas de concreto hidráulico, calle Ágata; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }13/N51/N51.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N51/JAN51.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N51/APN51.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N51/FAN51.pdf`,
                    },
                    ],
                },
        // Licitación N50
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N50-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 17 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Puente peatonal Xochihuacán; ubicada en la localidad de Xochihuacan, Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }13/N50/N50.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N50/JAN50.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N50/APN50.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N50/FAN50.pdf`,
                    },
                    ],
                },
        // Licitación N49
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N49-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 17 de septiembre  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica, banquetas y guarniciones en Tothie; ubicada en la localidad de El Tothie, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }13/N49/N49.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N49/JAN49.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N49/APN49.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N49/FAN49.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 011
            'numConvocatoria' : 'Convocatoria No. 011/2019.',
            'idConvocatoria' : 'Convocatoria11',
            'procedimientos' : [
        // Licitación N46
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N46-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 19 al 26 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Terminación del Centro Regional de Servicios Integrales de la Procuraduría General de Justicia del Estado de Hidalgo (Región Pachuca); ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }11/N46/N46.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }11/N46/JAN46.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }11/N46/APN46.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }11/N46/FAN46.pdf`,
                    },
                    ],
                },
        // Licitación N45
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N45-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 19 al 26 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Techumbre de arcotecho de bodegas 1,6 y 7 del Sistema DIF Hidalgo; ubicada en la localidad y Municipio de Pachuca de Soto, Estado Hidalgo.',
                    'urlAnexos' : `${ ligabase }11/N45/N45.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }11/N45/JAN45.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }11/N45/APN45.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }11/N45/FAN45.pdf`,
                    },
                    ],
                },
        // Licitación N44
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N44-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 19 al 26 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de acceso al Carrizal; ubicada en la localidad de El Carrizal, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }11/N44/N44.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }11/N44/JAN44.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }11/N44/APN44.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }11/N44/FAN44.pdf`,
                    },
                    ],
                },
        // Licitación N43
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N43-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 19 al 26 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de techado de cancha de usos múltiples en Sec. Técnica no. 57 Capula CCT13DST0059L; ubicada en la localidad de Capula, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }11/N43/N43.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }11/N43/JAN43.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }11/N43/APN43.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }11/N43/FAN43.pdf`,
                    },
                    ],
                },
        // Licitación N42
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N42-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 19 al 26 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de techado de Plaza Cultural Cerritos Remedios; ubicada en la localidad de Cerritos, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }11/N42/N42.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }11/N42/JAN42.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }11/N42/APN42.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }11/N42/FAN42.pdf`,
                    },
                    ],
                },
        // Licitación N41
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N41-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 19 al 26 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de Av. Francisco Villa; ubicada en la localidad Colonia 28 de Mayo (Santa Rosa), Municipio de Acatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }11/N41/N41.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }11/N41/JAN41.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }11/N41/APN41.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }11/N41/FAN41.pdf`,
                    },
                    ],
                },
        // Licitación N40
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N40-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 19 al 26 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de techado de cancha de usos múltiples Preescolar "Jaime Nunó" C.C.T. 13DCC0309J; ubicada en la localidad de El Dexthi San Juanico, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }11/N40/N40.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }11/N40/JAN40.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }11/N40/APN40.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }11/N40/FAN40.pdf`,
                    },
                    ],
                },
        // Licitación N39
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N39-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 19 al 26 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico de calle Prolongación Petirrojo (tramo Circuito Cardenal - calle Unión); ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }11/N39/N39.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }11/N39/JAN39.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }11/N39/APN39.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }11/N39/FAN39.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 010
            'numConvocatoria' : 'Convocatoria No. 010/2019.',
            'idConvocatoria' : 'Convocatoria10',
            'procedimientos' : [
        // Licitación N38
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N38-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 19 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Arcotecho en Telesecundaria de San Sebastián Tenochtitlán; ubicada en la localidad de San Sebastián Tenochtitlán, Municipio de Nopala de Villagrán, Estado de Hidalgo. (Segundo Procedimiento).',
                    'urlAnexos' : `${ ligabase }10/N38/N38.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N38/JAN38.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N38/APN38.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N38/FAN38.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 009
            'numConvocatoria' : 'Convocatoria No. 009/2019.',
            'idConvocatoria' : 'Convocatoria9',
            'procedimientos' : [
        // Licitación N37
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N37-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 19 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico, calle Esmeralda; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N37/N37.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N37/JAN37.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N37/APN37.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N37/FAN37.pdf`,
                    },
                    ],
                },
        // Licitación N36
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N36-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 19 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Rehabilitación de puente vehicular de C.E. (acceso Xochiatipan) - Río Garcés; ubicada en la localidad de Nuevo Acatepec (Mezcalapa), Municipio de Xochiatipan, Estado de Hidalgo. ',
                    'urlAnexos' : `${ ligabase }9/N36/N36.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N36/JAN36.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N36/APN36.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N36/FAN36.pdf`,
                    },
                    ],
                },
        // Licitación N35
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N35-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 19 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico, calle Turquesa; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N35/N35.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N35/JAN35.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N35/APN35.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N35/FAN35.pdf`,
                    },
                    ],
                },
        // Licitación N34
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N34-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 19 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico, calle Ámbar; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N34/N34.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N34/JAN34.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N34/APN34.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N34/FAN34.pdf`,
                    },
                    ],
                },
        // Licitación N33
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N33-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 19 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico, calle Cuarzo; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N33/N33.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N33/JAN33.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N33/APN33.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N33/FAN33.pdf`,
                    },
                    ],
                },
        // Licitación N32
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N32-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 19 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico, calle Aguamarina; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N32/N32.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N32/JAN32.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N32/APN32.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N32/FAN32.pdf`,
                    },
                    ],
                },
        // Licitación N31
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N31-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 16 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en Avenida Los Pinos, en la localidad de Patria Nueva, municipio de Santiago de Anaya; ubicada en la localidad de Patria Nueva, Municipio de Santiago de Anaya, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N31/N31.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N31/JAN31.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N31/APN31.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N31/FAN31.pdf`,
                    },
                    ],
                },
        // Licitación N30
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N30-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 16 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en calles de Vixtha; ubicada en la localidad de Vixtha de Madero, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N30/N30.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N30/JAN30.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N30/APN30.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N30/FAN30.pdf`,
                    },
                    ],
                },
        // Licitación N29
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N29-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 16 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Rehabilitación con pavimento asfáltico Santa Ana - Yemila (E.C. Tulancingo - Acaxochitlán), del Km. 0+000 al Km. 1+200; ubicada en la localidad de Santa Ana Tzacuala, Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N29/N29.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N29/JAN29.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N29/APN29.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N29/FAN29.pdf`,
                    },
                    ],
                },
        // Licitación N28
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N28-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 16 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Trabajos complementarios en la carretera Tehuetlan-Huejutla, del Km. 209+500 al Km. 212+500; ubicada en la localidad de Santa Catarina, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N28/N28.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N28/JAN28.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N28/APN28.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N28/FAN28.pdf`,
                    },
                    ],
                },
        // Licitación N27
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N27-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 16 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Reconstrucción de la carretera Hacienda La Concepción - acceso a Benito Juárez, tramos aislados; ubicada en la localidad de La Concepción, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N27/N27.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N27/JAN27.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N27/APN27.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N27/FAN27.pdf`,
                    },
                    ],
                },
        // Licitación N26
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N26-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 16 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Reconstrucción C.E. Tetepango Tlahuelilpan del Km 0+000 al Km 14+200, subtramo del Km 3+300 al Km 4+714; ubicada en varias localidades del Municipio de Tetepango, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N26/N26.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N26/JAN26.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N26/APN26.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N26/FAN26.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 008
            'numConvocatoria' : 'Convocatoria No. 008/2019.',
            'idConvocatoria' : 'Convocatoria8',
            'procedimientos' : [
        // Licitación N25
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N25-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 29 de julio al 6 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Rehabilitación con carpeta de concreto asfáltico del libramiento Madero, del Km 2+967 al Km 6+200; ubicada en la localidad de Tepatepec, Municipio de Francisco I. Madero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N25/N25.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N25/JAN25.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N25/APN25.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N25/FAN25.pdf`,
                    },
                    ],
                },
        // Licitación N24
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N24-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 29 de julio al 6 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Rehabilitación de carretera acceso a Irolo, del Km. 1+800 al Km. 2+800 (segunda etapa); ubicada en la localidad de Irolo, Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N24/N24.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N24/JAN24.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N24/APN24.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N24/FAN24.pdf`,
                    },
                    ],
                },
        // Licitación N23
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N23-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 29 de julio al 6 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Reconstrucción C.E. Santa Catarina - E.C.F. (Pachuca - Huejutla), del Km 0+000 al Km 1+500; ubicada en varias localidades del Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N23/N23.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N23/JAN23.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N23/APN23.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N23/FAN23.pdf`,
                    },
                    ],
                },
        // Licitación N22
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N22-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 29 de julio al 6 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Rehabilitación de infraestructura carretera estatal, C.E. Tecamatl - Ajacuba del Km. 0+000 al 37+000, subtramo a rehabilitar del Km. 31+045 al 32+900; ubicada en la localidad de Santiago Tezontlale, Municipio de Ajacuba, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N22/N22.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N22/JAN22.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N22/APN22.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N22/FAN22.pdf`,
                    },
                    ],
                },
        // Licitación N21
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N21-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 29 de julio al 6 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Sistema de agua potable en Santiago Tezontlale; ubicado en la localidad de Santiago Tezontlale, Municipio de Ajacuba, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N21/N21.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N21/JAN21.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N21/APN21.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N21/FAN21.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 007
            'numConvocatoria' : 'Convocatoria No. 007/2019.',
            'idConvocatoria' : 'Convocatoria7',
            'procedimientos' : [
        // Licitación N20
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N20-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 29 de julio al 5 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en acceso a Tula tramo el CERESO; ubicada en la localidad y Municipio de Tula de Allende, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }7/N20/N20.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }7/N20/JAN20.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }7/N20/APN20.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }7/N20/FAN20.pdf`,
                    },
                    ],
                },
        // Licitación N19
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N19-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 29 de julio al 5 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Terminación sustitución Centro de Salud Sta. María Amajac; ubicada en la localidad de Santa María Amajac, Municipio de Atotonilco El Grande, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }7/N19/N19.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }7/N19/JAN19.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }7/N19/APN19.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }7/N19/FAN19.pdf`,
                    },
                    ],
                },
        // Licitación N18
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N18-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 29 de julio al 5 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Conservación de la red carretera estatal mediante la aplicación de riego de sello reforzado con fibra de vidrio; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }7/N18/N18.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }7/N18/JAN18.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }7/N18/APN18.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }7/N18/FAN18.pdf`,
                    },
                    ],
                },
        // Licitación N17
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N17-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 29 de julio al 5 de agosto  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en camino San Miguel Huatengo (continuación); ubicada en la localidad de San Pedro Huatengo, Municipio de Santiago Tulantepec de Lugo Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }7/N17/N17.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }7/N17/JAN17.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }7/N17/APN17.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }7/N17/FAN17.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 006
            'numConvocatoria' : 'Convocatoria No. 006/2019.',
            'idConvocatoria' : 'Convocatoria6',
            'procedimientos' : [
        // Licitación N16
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N16-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de julio  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de línea de transmisión de 230 Kv de E.S.E. Km 110 a S.E. maniobras COFOIN; ubicada en la localidad de Acopinalco (Acopinalco y Tepetates), Municipio de Apan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }6/N16/N16.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }6/N16/JAN16.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }6/N16/APN16.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }6/N16/FAN16.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 005
            'numConvocatoria' : 'Convocatoria No. 005/2019.',
            'idConvocatoria' : 'Convocatoria5',
            'procedimientos' : [
        // Licitación N15
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N15-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de julio  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico de calle Gardenias de la colonia Luis Flores; ubicada en la localidad y Municipio de Atlapexco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N15/N15.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N15/JAN15.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }5/N15/APN15.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }5/N15/FAN15.pdf`,
                    },
                    ],
                },
        // Licitación N14
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N14-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de julio  de 2019.',
                    'descripcionProcedimiento' : 'Construcción y pavimentación con carpeta asfáltica de 5 cms de espesor de la calle 10 de Mayo; ubicada en la localidad de Cerritos, Municipio de Santiago de Anaya, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N14/N14.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N14/JAN14.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }5/N14/APN14.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }5/N14/FAN14.pdf`,
                    },
                    ],
                },
        // Licitación N13
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N13-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de julio  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación de calle Los Filtros-Dr. G. Parres 2da etapa del Km 4+300 al Km 4+780; ubicada en la localidad de Tepatepec, Municipio de Francisco I. Madero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N13/N13.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N13/JAN13.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }5/N13/APN13.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }5/N13/FAN13.pdf`,
                    },
                    ],
                },
        // Licitación N12
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N12-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de julio  de 2019.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica crucero San Luis Buenavista - vías del tren Altepemila (segunda etapa); ubicada en la localidad de Altepemila, Municipio de Santiago Tulantepec de Lugo Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N12/N12.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N12/JAN12.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }5/N12/APN12.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }5/N12/FAN12.pdf`,
                    },
                    ],
                },
        // Licitación N11
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N11-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de julio  de 2019.',
                    'descripcionProcedimiento' : 'Reconstruccion2025 auxiliares distribuidor vial Téllez (iluminación sobre puente - media tensión); ubicada en la localidad de Jagüey de Téllez (Estación Téllez), Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N11/N11.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N11/JAN11.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }5/N11/APN11.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }5/N11/FAN11.pdf`,
                    },
                    ],
                },
        // Licitación N10
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N10-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de julio  de 2019.',
                    'descripcionProcedimiento' : 'Rehabilitación de pavimento hidráulico de la calle Emiliano Zapata, del Barrio Axomol en la comunidad de Papatlatla, Calnali; ubicada en la localidad de Papatlatla, Municipio de Calnali, Estado de Hidalgo. ',
                    'urlAnexos' : `${ ligabase }5/N10/N10.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N10/JAN10.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }5/N10/APN10.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }5/N10/FAN10.pdf`,
                    },
                    ],
                },
        // Licitación N9
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N9-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de julio  de 2019.',
                    'descripcionProcedimiento' : 'Rehabilitación de puente vehicular de C.E. (Atlapexco-Mecatlán-Papatlatla)-Sta Teresa Km 2+100; ubicada en la localidad de Pepeyocatitla, Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N9/N9.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N9/JAN9.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }5/N9/APN9.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }5/N9/FAN9.pdf`,
                    },
                    ],
                },
        // Licitación N8
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N8-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de julio  de 2019.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en Av. Independencia, cabecera municipal; ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N8/N8.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N8/JAN8.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }5/N8/APN8.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }5/N8/FAN8.pdf`,
                    },
                    ],
                },
        // Licitación N7
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N7-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de julio  de 2019.',
                    'descripcionProcedimiento' : 'Arcotecho en Telesecundaria de San Sebastián Tenochtitlán; ubicada en la localidad de San Sebastián Tenochtitlán, Municipio de Nopala de Villagrán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N7/N7.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N7/JAN7.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }5/N7/APN7.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }5/N7/FAN7.pdf`,
                    },
                    ],
                },
        // Licitación N6
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N6-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de julio  de 2019.',
                    'descripcionProcedimiento' : 'Complemento de pavimentación asfáltica del camino de acceso a la comunidad de San Gabriel Azteca; ubicada en la localidad de San Gabriel Azteca, Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N6/N6.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N6/JAN6.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }5/N6/APN6.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }5/N6/FAN6.pdf`,
                    },
                    ],
                },
        // Licitación N5
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N5-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 26 de julio  de 2019.',
                    'descripcionProcedimiento' : 'Reconstrucción C.E. acceso a Grutas de Tolantongo del Km. 11+000 al Km. 11+800; ubicada en la localidad de El Cubo, Municipio de Cardonal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N5/N5.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N5/JAN5.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }5/N5/APN5.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }5/N5/FAN5.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 004
            'numConvocatoria' : 'Convocatoria No. 004/2019.',
            'idConvocatoria' : 'Convocatoria4',
            'procedimientos' : [
        // Licitación N4
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N4-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 14 de junio  de 2019.',
                    'descripcionProcedimiento' : 'Construcción del Centro de Servicios Integrales de la Procuraduría General de Justicia (Región Tulancingo) 3ª etapa; ubicada en la localidad de Santiago Tulantepec, Municipio de Santiago Tulantepec de Lugo Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }4/N4/N4.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }4/N4/JAN4.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }4/N4/APN4.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 003
            'numConvocatoria' : 'Convocatoria No. 003/2019.',
            'idConvocatoria' : 'Convocatoria3',
            'procedimientos' : [
        // Licitación N3
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N3-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 15 al 22 de abril  de 2019.',
                    'descripcionProcedimiento' : 'Creación de la Unidad Especializada de Atención a Niñas, Niños y Adolescentes, ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N3/N3.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N3/JAN3.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N3/APN3.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N3/FAN3.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 002
            'numConvocatoria' : 'Convocatoria No. 002/2019.',
            'idConvocatoria' : 'Convocatoria2',
            'procedimientos' : [
        // Licitación N2
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N2-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 8 al 15 de abril  de 2019.',
                    'descripcionProcedimiento' : 'Relocalización de líneas de media tensión en Acopinalco, ubicada en la localidad de Acopinalco (Acopinalco y Tepetates), Municipio de Apan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }2/N2/N2.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }2/N2/JAN2.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }2/N2/APN2.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }2/N2/FAN2.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }2/N2/AMDFAN2.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 001
            'numConvocatoria' : 'Convocatoria No. 001/2019.',
            'idConvocatoria' : 'Convocatoria1',
            'procedimientos' : [
        // Licitación N1
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N1-2019.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 15 de marzo  de 2019.',
                    'descripcionProcedimiento' : 'Terminación de la Unidad Médica Tulancingo edificio A y B, ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N1/N1.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }1/N1/JAN1.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }1/N1/APN1.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }1/N1/FAN1.pdf`,
                    },
                    ],
                },
            ],
    },
]